
<!-- drawer init and show -->
 <div [class.dark]="darkMode" class="h-full w-full flex flex-col justify-start dark:bg-d1">
  <button data-drawer-target="default-sidebar" data-drawer-toggle="default-sidebar" aria-controls="default-sidebar" type="button" class="inline-flex items-center p-2 mt-2 ms-3 text-sm text-gray-500 rounded-lg sm:hidden hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200 dark:text-gray-400 dark:hover:bg-gray-700 dark:focus:ring-gray-600">
    <span class="sr-only">Open sidebar</span>
    <svg class="w-6 h-6" aria-hidden="true" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
    <path clip-rule="evenodd" fill-rule="evenodd" d="M2 4.75A.75.75 0 012.75 4h14.5a.75.75 0 010 1.5H2.75A.75.75 0 012 4.75zm0 10.5a.75.75 0 01.75-.75h7.5a.75.75 0 010 1.5h-7.5a.75.75 0 01-.75-.75zM2 10a.75.75 0 01.75-.75h14.5a.75.75 0 010 1.5H2.75A.75.75 0 012 10z"></path>
    </svg>
  </button>

  <aside id="default-sidebar" class="fixed top-0 left-0 z-10 w-[200px] h-screen transition-transform -translate-x-full sm:translate-x-0" aria-label="Sidebar">
    <div class="h-full flex flex-col px-2 py-1 pt-2 overflow-y-auto bg-os_winter_blue dark:bg-d1">
      <h2 class="py-2 mb-2 text-os_winter_light_blue text-center dark:text-d4 text-lg font-medium select-none">
        Option <span class="text-gray-200 dark:text-gray-200">Sniper {{tier.level}}</span>
      </h2>
      <ul class="font-medium text-[13px] flex-1 select-none">
          <li *ngFor="let scan of scans">
            <a class="flex items-center p-2 text-white rounded-md dark:text-white hover:bg-os_winter_light_blue/10 dark:hover:bg-gray-700 group scan-link"
                [class.selected]="current_scan == scan.key && !darkMode"
                [class.dark-selected]="current_scan == scan.key && darkMode"
                (click)="on_current_scan_change(scan.key)">
                <span class="" [class.text-gray-400]="!scan._enabled">
                  <span *ngIf="scan.all_star == true">
                    <i *ngIf="scan.group == 'Scan_6'" class="fa-solid fa-bullseye fa-fw text-[#008B00] dark:text-[#008B00]/80 mr-1"></i>
                    <i *ngIf="scan.group == 'Scan_7_9'" class="fa-solid fa-bullseye fa-fw text-[#008B00] dark:text-[#008B00] mr-1"></i>
                    <i *ngIf="scan.group == 'Scan_10'" class="fa-solid fa-bullseye fa-fw text-[#009d8c] dark:text-[#009d8c] mr-1"></i>
                    <i *ngIf="scan.group == 'Scan_2_Years'" class="fa-solid fa-clock fa-fw text-[#cfd200] mr-1"></i>
                  </span>
                  {{scan.label}}
                  <span *ngIf="scan._alert_count" class="ml-1 text-nowrap rounded-full bg-os_winter_light_blue dark:bg-d4 px-2 text-xs text-black dark:text-white font-bold">
                    {{scan._alert_count}}
                  </span>
                </span>
                <span *ngIf="scan._enabled && scan._live != true" class="ml-auto">
                  <span class="bg-[#910000] text-white text-[10px] font-semibold rounded-sm px-1 py-0.5 ml-2">DELAYED</span>
                </span>
                <span *ngIf="!scan._enabled" class="ml-auto text-[#8c8c8c]">
                  <i class="fa-solid fa-lock fa-fw"></i>
                </span>
            </a>
            <div *ngIf="scan.break == true" class="h-auto my-2 w-full border-t border-os_winter_light_blue dark:border-d3 select-none"></div>
          </li>
      </ul>
    </div>
  </aside>

  <div class="sm:ml-[200px] grid-container relative">
    <div class="w-full p-2 px-4 bg-os_winter_blue/20 dark:bg-grid_bg_dark flex items-center text-sm text-gray-600 dark:text-gray-400">
      
      <!-- Date Picker -->
      <div class="relative max-w-sm mr-4">
        <div class="absolute inset-y-0 start-0 flex items-center ps-3.5 pointer-events-none">
          <svg class="w-4 h-4 text-gray-500 dark:text-gray-400" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20"
            [style.fill]="getLiveColor()">
          >
            <path d="M20 4a2 2 0 0 0-2-2h-2V1a1 1 0 0 0-2 0v1h-3V1a1 1 0 0 0-2 0v1H6V1a1 1 0 0 0-2 0v1H2a2 2 0 0 0-2 2v2h20V4ZM0 18a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8H0v10Zm5-8h10a1 1 0 0 1 0 2H5a1 1 0 0 1 0-2Z"/>
          </svg>
        </div>
        <input datepicker datepicker-autohide [attr.datepicker-max-date]="today" id="default-datepicker" type="text" class="select-none cursor-pointer focus:outline-none bg-transparent hover:bg-gray-300 hover:text-os_winter_blue rounded-sm border border-gray-400 text-sm focus:ring-1 focus:ring-os_winter_gray dark:focus:ring-gray-700 block w-full ps-10 p-1 dark:bg-transparent dark:border-gray-600 dark:placeholder-gray-400 dark:hover:bg-gray-700 dark:hover:text-white"
          placeholder="Select date" [ngModel]="dateMode" readonly (hide)="on_date_change($event)" style="caret-color: transparent;">
      </div>

      <!-- Clear filter button -->
      <button class="py-1 px-2 font-normal select-none focus:outline-none bg-transparent rounded-sm border border-gray-400 hover:bg-gray-300 hover:text-os_winter_blue focus:z-10 focus:ring-1 focus:ring-os_winter_gray dark:focus:ring-gray-700 dark:bg-transparent dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700"
        (click)="clear_all_filters()">
        <i class="fa-solid fa-filter fa-flip-horizontal mr-1"></i>
        clear filters
      </button>

      <!-- Report Query -->
      <!-- <button (click)="getReportSymbols(current_scan)"> -->
      <button *ngIf="reports_allowed() && !show_reports" (click)="on_show_reports_click()" class="ml-4 py-1 px-2 font-normal select-none focus:outline-none bg-transparent rounded-sm border border-gray-400 hover:bg-gray-300 hover:text-os_winter_blue focus:z-10 focus:ring-1 focus:ring-os_winter_gray dark:focus:ring-gray-700 dark:bg-transparent dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700">
        <i class="fa-solid fa-table-cells mr-1"></i> Report
      </button>
      <button *ngIf="reports_allowed() && show_reports" (click)="show_reports = false" class="ml-4 py-1 px-2 font-normal select-none focus:outline-none bg-transparent rounded-sm border border-gray-400 hover:bg-gray-300 hover:text-os_winter_blue focus:z-10 focus:ring-1 focus:ring-os_winter_gray dark:focus:ring-gray-700 dark:bg-transparent dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700">
        <i class="fa-solid fa-door-open mr-1 text-[#c7a700]"></i> Close
      </button>

      <!-- Dark mode toggle -->
      <button type="button" class="ml-auto select-none hover:text-os_winter_blue font-medium text-center inline-flex items-center dark:bg-transparent dark:hover:text-gray-200"
        click="toggleDarkMode()">
        <ng-container *ngIf="!darkMode">
          <span class="fa-stack" (click)="toggleDarkMode()">
            <i class="fa-solid fa-circle fa-stack-2x text-gray-600/15"></i>
            <i class="fa-solid fa-sun fa-stack-1x"></i>
          </span>
        </ng-container>
        <ng-container *ngIf="darkMode">
          <span class="fa-stack" (click)="toggleDarkMode()">
            <i class="fa-solid fa-circle fa-stack-2x text-d2/35"></i>
            <i class="fa-solid fa-moon fa-stack-1x"></i>
          </span>
        </ng-container>
        <span class="sr-only">mode</span>
      </button>

    </div>

    <div *ngIf="current_scan && !scansMap[current_scan]?._enabled"
    class="absolute top-0 left-0 z-10 w-full h-full
    flex flex-col justify-center items-center text-2xl select-none
    bg-[#31465bfa] dark:bg-[#1f2133f2]">
      <span class="text-3xl text-white mb-4"><i class="fa-solid fa-lock"></i></span>
      <span class="text-[#61dfff] dark:text-d4">{{scansMap[current_scan]?.label}}</span>
      <span class="text-gray-200 text-lg">Please contact customer support to gain access.</span>
    </div>

    <ag-grid-angular
      class="data-grid"
      [theme]="theme"
      [gridOptions]="grid.options"
      [columnDefs]="grid.columnDefs"
      [rowData]="data"
      (gridReady)="on_grid_ready($event)"
      (modelUpdated)="on_model_updated($event)"
    />
    <div class="grid-footer text-black dark:text-white bg-gray-100 dark:bg-grid_footer_dark dark:border-[#3E3B45] select-none">
      <span class="key-value">
        <span class="key">Total:</span>
        <span class="value">{{data.length}}</span>
      </span>
      <span class="key-value ml-6">
        <span class="key">Showing:</span>
        <span class="value">{{filtered_data.length}}</span>
      </span>
      <a href="https://f2-tech.com" target="_blank" class="ml-auto text-center text-os_winter_mid dark:text-[#656994] opacity-90 select-none hover:opacity-100">
        Powered by <span class="text-gray-700 dark:text-gray-200">F2Tech</span>
      </a>
      <!-- Socket connection indicator -->
      <span class="ml-2 select-none" [class.text-red-500]="!_socket || !_socket.connected" [class.text-green-500]="_socket?.connected" data-tooltip-target="tooltip-conn">
        <i class="fa-solid fa-power-off"></i>
        <div id="tooltip-conn" role="tooltip" class="absolute z-10 invisible inline-block px-3 py-2 text-sm text-white transition-opacity duration-300 bg-gray-600 rounded-sm shadow-sm opacity-0 tooltip dark:bg-d1">
          <span *ngIf="!_socket || !_socket.connected">Disconnected</span>
          <span *ngIf="_socket?.connected">Connected</span>
          <div class="tooltip-arrow" data-popper-arrow></div>
        </div>
      </span>
    </div>

    <div *ngIf="show_reports" class="absolute top-[45px] left-0 z-10 w-full h-[calc(100%-45px)] flex flex-col bg-[#D5D9DD] dark:bg-grid_bg_dark text-gray-800 dark:text-white select-none flex flex-col p-4">
      <div class="mb-2 flex justify-start items-center flex-wrap">
        <span class="flex items-center mr-4">
          <div class="flex items-center h-full p-1 ps-3 pr-3 pointer-events-none text-sm text-white bg-[#3F5872] dark:bg-d1 border border-gray-400 dark:border-gray-600">
            Report
          </div>
          <select #reports class="ml-[-1px] w-auto p-1 text-sm focus:outline-none bg-[#D1D5DB] rounded-sm border border-gray-400 hover:bg-gray-300 hover:text-os_winter_blue focus:z-10 focus:ring-1 focus:ring-os_winter_gray dark:focus:ring-gray-700 dark:bg-[#1C1924] dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700"
            (change)="onSelectedReportChange(reports.value)">
            <option *ngFor="let r of available_reports" [value]="r">{{r}}</option>
          </select>
        </span>

        <span class="relative mr-4">
          <div class="absolute inset-y-0 start-0 flex items-center ps-3 pr-3 pointer-events-none text-sm text-white bg-[#3F5872] dark:bg-d1 border border-gray-400 dark:border-gray-600">
            Symbol
          </div>
          <input class="block w-[175px] p-1 ps-20 text-sm focus:outline-none bg-transparent rounded-sm border border-gray-400 hover:bg-gray-300 hover:text-os_winter_blue focus:z-10 focus:ring-1 focus:ring-os_winter_gray dark:focus:ring-gray-700 dark:bg-transparent dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700"
            [(ngModel)]="report_symbol" style="text-transform: uppercase" (keyup)="on_report_symbol_keyup($event)"/>
        </span>
        
        <button class="flex items-center p-1 py-1 px-2 text-nowrap font-normal select-none text-gray-600 dark:text-gray-300 focus:outline-none bg-transparent rounded-sm border border-gray-400 hover:bg-gray-300 hover:text-os_winter_blue focus:z-10 focus:ring-1 focus:ring-os_winter_gray dark:focus:ring-gray-700 dark:bg-transparent dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700"
          [disabled]="!report_symbol" (click)="getReportData(report_symbol)">
          <i class="fa-solid fa-database mr-2"></i> Get Report
        </button>
      </div>
      <div *ngIf="report" class="mb-2 mt-4 flex justify-start items-center flex-wrap">
        <div class="flex items-center mr-4">
          <input id="default-radio-1" type="radio" value="all" name="default-radio" [(ngModel)]="report_type" (change)="set_report_data_from_type()" class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300  dark:bg-gray-700 dark:border-gray-600">
          <label for="default-radio-1" class="ms-2 text-sm font-medium text-gray-600 dark:text-gray-300">All</label>
        </div>
        <div class="flex items-center mr-4">
          <input checked id="default-radio-2" type="radio" value="calls" name="default-radio" [(ngModel)]="report_type" (change)="set_report_data_from_type()" class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300  dark:bg-gray-700 dark:border-gray-600">
          <label for="default-radio-2" class="ms-2 text-sm font-medium text-gray-600 dark:text-gray-300">Calls</label>
        </div>
        <div class="flex items-center mr-10">
          <input checked id="default-radio-3" type="radio" value="puts" name="default-radio" [(ngModel)]="report_type" (change)="set_report_data_from_type()" class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300  dark:bg-gray-700 dark:border-gray-600">
          <label for="default-radio-3" class="ms-2 text-sm font-medium text-gray-600 dark:text-gray-300">Puts</label>
        </div>
        <div *ngIf="report" class="flex-1 flex items-center text-sm text-gray-600 dark:text-gray-300 font-semibold text-nowrap">
          <span class="mr-10">Total Trade Count: {{report?.tradeCount || '0'}}</span>
          <span class="flex items-center">
            Rank: {{getReportRank()}}
            <span class="ml-2" [style.color]="report[report_type].rankColor.color">
              <span *ngIf="report[report_type].rankColor.count == 2"><i class="fa-solid fa-angles-up"></i></span>
              <span *ngIf="report[report_type].rankColor.count == 1"><i class="fa-solid fa-angle-up"></i></span>
            </span>
          </span>
          <span class="ml-auto mr-1 dark:text-gray-300">
            Last Updated: {{report?.lastUpdated}}
          </span>
        </div>
      </div>
        <!-- <ag-grid-angular
          class="report-grid"
          [theme]="theme"
          [gridOptions]="report_grid?.options"
          [columnDefs]="report_grid?.columnDefs"
          [rowData]="report_data"
          (gridReady)="on_report_grid_ready($event)"
        /> -->
      <ng-container *ngIf="report">
        <div class="text-center font-semibold py-1 px-2 bg-blue dark:bg-[#004d50]" style="border-top-left-radius: 2px; border-top-right-radius: 2px;">
          Half Risk - 50% Stop Loss
        </div>
        <table>
          <thead>
            <th class="text-left font-normal dark:text-gray-200 border-0 border-b-2 dark:border-[#006376] py-1 px-2 dark:bg-gradient-to-b from-[#004d50]/50 to-[#2b2d41]">Profit Target</th>
            <th class="font-normal dark:text-gray-200 border-0 border-b-2 dark:border-[#006376] py-1 px-2 dark:bg-gradient-to-b from-[#004d50]/50 to-[#2b2d41]">
              Win Rate
            </th>
            <th class="font-normal dark:text-gray-200 border-0 border-b-2 dark:border-[#006376] py-1 px-2 dark:bg-gradient-to-b from-[#004d50]/50 to-[#2b2d41]">
              Profit / Contract
            </th>
            <th class="font-normal dark:text-gray-200 border-0 border-b-2 dark:border-[#006376] py-1 px-2 dark:bg-gradient-to-b from-[#004d50]/50 to-[#2b2d41]">
              Average Profit / Contract
            </th>
            <th class="font-normal dark:text-gray-200 border-0 border-b-2 dark:border-[#006376] py-1 px-2 dark:bg-gradient-to-b from-[#004d50]/50 to-[#2b2d41]">
              Average Hold Days
            </th>
          </thead>
          <tbody>
            <ng-container *ngFor="let r of report_data; let odd = odd">
              <tr *ngIf="r.stopLoss == '50%'" class="text-center text-gray-300 hover:dark:bg-[#3449551a]" [class.dark:bg-[#ffffff0d]]="odd">
                <td class="text-left w-[175px] py-1 px-2 flex">
                  <span class="flex-0 w-[45px] mr-2">{{r.takeProfit}}</span>
                  <span class="flex-1">{{getReportProfitTargetText(r.takeProfit)}}</span>
                </td>
                <td class="py-1 px-2">{{roundReportWinRate(r.winRate)}}</td>
                <td class="py-1 px-2">{{convertReportPnlToDollarValue(r.winPnL) | currency: '$' : '$' : '1.0'}}</td>
                <td class="py-1 px-2">{{convertReportPnlToDollarValue(r.winMeanPnL) | currency: '$' : '$' : '1.0'}}</td>
                <td class="py-1 px-2">{{convertReportMeanHoldDays(r.winMeanHoldDays)}}</td>
              </tr>
            </ng-container>
          </tbody>
        </table>

        <div class="text-center font-semibold mt-8 py-1 px-2 bg-blue dark:bg-[#a36900]" style="border-top-left-radius: 2px; border-top-right-radius: 2px;">
          Full Risk - 99% Stop Loss
        </div>
        <table>
          <thead>
            <th class="text-left font-normal dark:text-gray-200 border-0 border-b-2 dark:border-[#744b00] py-1 px-2 dark:bg-gradient-to-b from-[#a36900]/60 to-[#302108]">
              Profit Target
            </th>
            <th class="font-normal dark:text-gray-200 border-0 border-b-2 dark:border-[#744b00] py-1 px-2 dark:bg-gradient-to-b from-[#a36900]/60 to-[#302108]">
              Win Rate
            </th>
            <th class="font-normal dark:text-gray-200 border-0 border-b-2 dark:border-[#744b00] py-1 px-2 dark:bg-gradient-to-b from-[#a36900]/60 to-[#302108]">
              Profit / Contract
            </th>
            <th class="font-normal dark:text-gray-200 border-0 border-b-2 dark:border-[#744b00] py-1 px-2 dark:bg-gradient-to-b from-[#a36900]/60 to-[#302108]">
              Average Profit / Contract
            </th>
            <th class="font-normal dark:text-gray-200 border-0 border-b-2 dark:border-[#744b00] py-1 px-2 dark:bg-gradient-to-b from-[#a36900]/60 to-[#302108]">
              Average Hold Days
            </th>
          </thead>
          <tbody>
            <ng-container *ngFor="let r of report_data; let odd = odd">
              <tr *ngIf="r.stopLoss == '99%'" class="text-center text-gray-300 hover:dark:bg-[#3449551a]" [class.dark:bg-[#ffffff0d]]="odd">
                <td class="text-left w-[175px] py-1 px-2 flex">
                  <span class="flex-0 w-[45px] mr-2">{{r.takeProfit}}</span>
                  <span class="flex-1">{{getReportProfitTargetText(r.takeProfit)}}</span>
                </td>
                <td class="py-1 px-2">{{roundReportWinRate(r.winRate)}}</td>
                <td class="py-1 px-2">{{convertReportPnlToDollarValue(r.winPnL) | currency: '$' : '$' : '1.0'}} {{r.winPnl}}</td>
                <td class="py-1 px-2">{{convertReportPnlToDollarValue(r.winMeanPnL) | currency: '$' : '$' : '1.0'}}</td>
                <td class="py-1 px-2">{{convertReportMeanHoldDays(r.winMeanHoldDays)}}</td>
              </tr>
            </ng-container>
          </tbody>
        </table>
      </ng-container>
  </div>
</div>

